import { useMemo } from 'react'
import axios from 'axios'
import { getDataByPath } from '@usap/core'
import dateFormat from '../helpers/dateFormat'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'
import nrLogger from '../helpers/nrLogger'
import { cnstrcEvents } from '../helpers'
import shoppingCartV2API from '../components/ShoppingCartV2/api'

const { cnstrcUserLogout } = cnstrcEvents

const apiKey = {
  headers: {
    apikey: apiConfig.apiKey,
  },
}

const loginApiUrl = `${apiConfig.apiURL}/auth/v1/myaccount/login`
const logoutApiUrl = `${apiConfig.apiURL}/auth/v1/myaccount/logout`

const getEncryptedPassword = password => {
  if (window.JSEncrypt) {
    const encrypt = new window.JSEncrypt()
    encrypt.setPublicKey(config.authPublicKey)
    return encrypt.encrypt(password)
  }
  setTimeout(() => getEncryptedPassword(password), 100)
}

const getLoginParam = (orderId, loginInfo) => ({
  iat: dateFormat,
  order_id: String(orderId || '').trim(),
  username: loginInfo && loginInfo.loginEmail.trim(),
  password: loginInfo && getEncryptedPassword(loginInfo.loginPassword),
  domain: config.hydra.site,
  'g-recaptcha-response': loginInfo.captcha,
  "isInvRecaptchaEnabled": loginInfo.isInvRecaptchaEnabled,
})

const useUserAPIController = () => useMemo(
  () => ({
    userLogin: async (loginInfo, orderId) => {
      try {
        const body = getLoginParam(orderId, loginInfo)
        const loginRes = await axios.post(loginApiUrl, body, apiKey)
        const tokenDb = getDataByPath(loginRes, ['data', 'data'], {})
        if (orderId) {
          await shoppingCartV2API.collections.merge(tokenDb?.accessToken || tokenDb?.access_token, orderId)
        }
        return tokenDb
      } catch (err) {
        nrLogger.error('userLoginFail', err)
        throw err
      }
    },
    socialLogin: async ({ authCode, providerId, cartId }) => {
      const apiUrl = `${apiConfig.apiURL}/auth/v1/myaccount/social-login`
      const payload = {
        domain: config.hydra.site,
        code: authCode,
        providerId,
      }
      const res = await axios.post(apiUrl, payload, apiKey)
      const tokenDb = getDataByPath(res, ['data', 'data'], {})
      if (cartId) {
        await shoppingCartV2API.collections.merge(tokenDb?.accessToken || tokenDb?.access_token, cartId)
      }
      return tokenDb
    },
    userLogout: async ({
      access_token: accessToken,
    }) => {
      try {
        const headers = {
          headers: {
            apikey: apiConfig.apiKey,
            accessToken,
          }
        }

        const response = await axios.post(logoutApiUrl, '', headers)
        cnstrcUserLogout()
        return response
      } catch (err) {
        nrLogger.error('userLogoutFail', err)
        throw err
      }
    },
  }),
  [],
)

export default useUserAPIController
